import React from 'react';
import {t} from "react-switch-lang";

function EditBtn({setDisabled}) {

    const edit = () => {
        setDisabled(false);
        // window.location = window.location.href + '/edit';
    };
    return (
        <div style={{height: '40px'}} className={'w-100'}>
            <button
                className="primary-btn mr-3 float-right"
                onClick={(event) => {
                    event.preventDefault();
                    edit();
                }}
            >
                {t('common.edit')}
            </button>
        </div>
    );
}

export default EditBtn;